/* eslint-disable perfectionist/sort-objects */
import defaultConfig from "tailwindcss/defaultConfig";

const { theme } = defaultConfig;

const getThemeSpacing = () => {
  return {
    // https://www.radix-ui.com/themes/docs/theme/layout#spacing-scale
    // https://github.com/radix-ui/themes/blob/main/packages/radix-ui-themes/src/styles/tokens/space.css
    // https://tailwindcss.com/docs/customizing-spacing#default-spacing-scale

    ...theme?.spacing,

    // radix 1 is 4px, just like tailwind (0.25rem x 16px = 4px)
    rx1: "var(--space-1)",
    rx2: "var(--space-2)",
    rx3: "var(--space-3)",
    rx4: "var(--space-4)",
    // radix 5 is 24px while tailwind 5 is 20px | tailwind 6 is 24px
    rx5: "var(--space-5)",
    // radix 6 is 32px while tailwind 6 is 24px | tailwind 8 is 32px
    rx6: "var(--space-6)",
    // radix 7 is 40px while tailwind 7 is 28px | tailwind 10 is 40px
    rx7: "var(--space-7)",
    // radix 8 is 48px while tailwind 8 is 32px | tailwind 12 is 48px
    rx8: "var(--space-8)",
    // radix 9 is 64px while tailwind 9 is 36px | tailwind 16 is 64px
    rx9: "var(--space-9)",
  };
};

export { getThemeSpacing };
